"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var Player = (function (_super) {
    __extends(Player, _super);
    function Player() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playerInterval = null;
        _this.playerPoll = null;
        return _this;
    }
    Player.prototype.getPlayerType = function () {
        return this.playerType;
    };
    Player.prototype.init = function () {
        this.isSafari = window.Meister.Browser.isSafari
            ? window.Meister.Browser.isSafari
            : false;
        this.playerType = this.el.data("type");
        this.activePlayer = window.playerProperties.activePlayer;
        this.BNRArchivePlayer = window.BNRPlayer;
        this.playerImage = window.playerProperties.image;
        window.onbeforeunload = this.beforeUnload.bind(this);
        this.totalTimeSpent = 0;
        this.elapsedIntervalAmount = 0;
        this.isPlaying = false;
        this.maxInterVal = 30;
        var meisterPlayerConfig = {
            global: {
                autoplay: true,
                defaultAudioImage: this.playerImage,
                iosPlaysInline: true
            },
            AdItem: {},
            GoogleIma: {
                scriptUrl: "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
                onImaAvailable: function () {
                    window.google.ima.settings.setNumRedirects(4);
                    window.google.ima.settings.setVpaidMode(window.google.ima.ImaSdkSettings.VpaidMode.INSECURE);
                }
            },
            Hls: {
                disabled: this.isSafari
            },
            HtmlUi: {
                standard: {
                    stepBack: 10,
                    stepForward: 10,
                    qualityMapping: [
                        {
                            from: -1,
                            to: 0,
                            resolution: "auto"
                        },
                        {
                            from: 0,
                            to: 200000,
                            resolution: "160p"
                        },
                        {
                            from: 200000,
                            to: 1200000,
                            resolution: "360p"
                        },
                        {
                            from: 1200000,
                            to: 2850000,
                            resolution: "720p"
                        },
                        {
                            from: 2850000,
                            to: 6000000,
                            resolution: "1080p"
                        }
                    ]
                },
                ui: "<div class=\"mstr-container\" data-mstr-directive=\"autoHideShow,togglePlayPauseClick\">\n                        <div class=\"mstr-centerbar\">\n                            <span data-mstr-standard=\"spinner\"></span>\n                        </div>\n                        <div class=\"mstr-bottombar\">\n                            <div class=\"mstr-items\">\n                                <div class=\"mstr-item\">\n                                    <span data-mstr-standard=\"playbutton\"></span>\n                                </div>\n                                <div class=\"mstr-item\">\n                                    <span data-mstr-standard=\"stepbackbutton\"></span>\n                                </div>\n                                <div class=\"mstr-item mstr-item--fill\">\n                                    <span data-mstr-standard=\"seekbar\"></span>\n                                </div>\n                                <div class=\"mstr-item\">\n                                    <span data-mstr-standard=\"timedisplay\"></span>\n                                </div>\n                                <div class=\"mstr-item\">\n                                    <span data-mstr-standard=\"volumeslider\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>"
            }
        };
        if (this.activePlayer === "audioArchiveFragmentPlayer") {
            this.startMeisterArchivePlayer(meisterPlayerConfig, window.playerProperties);
        }
        else if (this.activePlayer === "liveAudioPlayer" ||
            this.activePlayer === "liveVideoPlayer" ||
            this.activePlayer === "audioFragmentPlayer") {
            this.startMeisterPlayer(meisterPlayerConfig, window.playerProperties);
        }
    };
    Player.prototype.startMeisterArchivePlayer = function (meisterPlayerConfig, playerProperties) {
        var startTime = playerProperties.startTime / 1000;
        var duration = playerProperties.stopTime / 1000 - startTime;
        var MeisterArchivePlayer = new this.BNRArchivePlayer({
            element: ".meisterplayer",
            starttime: startTime,
            duration: duration,
            src: window.playerProperties.src,
            config: meisterPlayerConfig,
            item: { mediaType: "audio" }
        });
        this.meisterplayer = MeisterArchivePlayer.player;
        this.archiveFragmentStartTime = this.formatDate(new Date(playerProperties.startTime));
        this.clientStartTime = this.getCurrentTime();
        this.meisterPlayerEvents();
    };
    Player.prototype.startMeisterPlayer = function (meisterPlayerConfig, playerProperties) {
        var _this = this;
        var meisterPlayer = new Meister(".meisterplayer", meisterPlayerConfig);
        this.meisterplayer = meisterPlayer;
        this.meisterplayer.setItem({
            type: "aditem",
            media: playerProperties,
            vmap: playerProperties.vmap !== undefined ? playerProperties.vmap.src : ""
        });
        if (this.isSafari) {
            this.meisterplayer.one("adBreakEnded", function () {
                if (_this.meisterplayer.playerPlugin.mediaElement.src !==
                    playerProperties.src) {
                    _this.meisterplayer.playerPlugin.mediaElement.src =
                        playerProperties.src;
                }
            });
        }
        this.meisterplayer.load();
        this.meisterPlayerEvents();
    };
    Player.prototype.meisterPlayerEvents = function () {
        var _this = this;
        var bus = Widget_1.Widget.getBus();
        this.meisterplayer.on("playerCreated", function () {
            _this.currentPlayerVolume = _this.meisterplayer.volume;
        });
        this.meisterplayer.on("playerPlaying", function () {
            _this.isPlaying = true;
            bus.notify(_this.activePlayer + ".play", _this.getData());
            _this.startAudioFragmentPercentageInterval();
            _this.startPlayerPoll();
        });
        this.meisterplayer.on("playerPause", function () {
            _this.isPlaying = false;
            bus.notify(_this.activePlayer + ".pause", _this.getData());
            _this.clearAudioFragmentPercentageInterval();
        });
        this.meisterplayer.on("playerBuffering", function () {
            _this.isPlaying = false;
            _this.clearAudioFragmentPercentageInterval();
        });
        this.meisterplayer.on("playerEnd", function () {
            _this.isPlaying = false;
            bus.notify(_this.activePlayer + ".end", _this.getData());
            if (_this.activePlayer === "audioFragmentPlayer") {
                _this.currentFragmentPercentage = 100;
                Widget_1.Widget.getBus().notify(_this.activePlayer + ".percentage", _this.getData());
            }
            _this.clearAudioFragmentPercentageInterval();
        });
        var playerVolumeChangeEvent = this.debounce(function () {
            _this.playerVolumeChangeEvent();
        }, 3000);
        this.meisterplayer.on("playerVolumeChange", playerVolumeChangeEvent);
    };
    Player.prototype.playerVolumeChangeEvent = function () {
        Widget_1.Widget.getBus().notify(this.activePlayer + ".volume", this.getData());
        this.currentPlayerVolume = Meister.instances[0].instance.volume;
    };
    Player.prototype.debounce = function (func, delay) {
        var timeoutId;
        return function () {
            var args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                func.apply(null, args);
            }, delay);
        };
    };
    Player.prototype.beforeUnload = function () {
        var bus = Widget_1.Widget.getBus();
        if (Meister.instances.length) {
            this.endDate = this.getCurrentTime();
            bus.notify(this.activePlayer + ".close", this.getData());
        }
    };
    Player.prototype.startAudioFragmentPercentageInterval = function () {
        var _this = this;
        var meisterInstance = Meister.instances[0].instance;
        if (this.activePlayer === "audioFragmentPlayer") {
            this.playerInterval = setInterval(function () {
                _this.audioFragmentPercentageEvent();
            }, meisterInstance.duration * 10);
        }
    };
    Player.prototype.clearAudioFragmentPercentageInterval = function () {
        if (this.activePlayer === "audioFragmentPlayer") {
            clearInterval(this.playerInterval);
        }
    };
    Player.prototype.startPlayerPoll = function () {
        var _this = this;
        clearInterval(this.playerPoll);
        this.playerPoll = setInterval(function () {
            if (_this.isPlaying) {
                _this.elapsedIntervalAmount += 1;
                _this.totalTimeSpent += 1;
                if (_this.elapsedIntervalAmount >= _this.maxInterVal) {
                    _this.elapsedIntervalAmount = 0;
                    _this.playerPollEvent();
                }
            }
        }, 1000);
    };
    Player.prototype.playerPollEvent = function () {
        if (this.activePlayer === "audioFragmentPlayer" ||
            this.activePlayer === "audioArchiveFragmentPlayer") {
            Widget_1.Widget.getBus().notify(this.activePlayer + ".listeningtime", this.getData());
        }
    };
    Player.prototype.audioFragmentPercentageEvent = function () {
        var percentages = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
        var meisterInstance = Meister.instances[0].instance;
        var currentPercentage = Math.floor((meisterInstance.currentTime / meisterInstance.duration) * 100);
        for (var i = 0; i < percentages.length; i++) {
            if (currentPercentage == percentages[i] &&
                (!this.currentFragmentPercentage ||
                    (this.currentFragmentPercentage &&
                        this.currentFragmentPercentage != currentPercentage))) {
                this.currentFragmentPercentage = currentPercentage;
                Widget_1.Widget.getBus().notify(this.activePlayer + ".percentage", this.getData());
            }
        }
    };
    Player.prototype.getCurrentTime = function (date) {
        if (date === void 0) { date = new Date(); }
        function pad(value) {
            return ("00" + value).slice(-2);
        }
        var hours = pad(date.getHours());
        var minutes = pad(date.getMinutes());
        return [hours, minutes].join(":");
    };
    Player.prototype.formatDate = function (d) {
        function pad(n) {
            return n < 10 ? "0" + n : n;
        }
        return (pad(d.getDate()) +
            "-" +
            pad(d.getMonth() + 1) +
            "-" +
            d.getFullYear() +
            " " +
            pad(d.getHours()) +
            ":" +
            pad(d.getMinutes()) +
            ":" +
            pad(d.getSeconds()));
    };
    Player.prototype.getData = function () {
        var meisterInstance = Meister.instances[0].instance;
        var data = {
            playerElapsed: Math.floor(meisterInstance.currentTime),
            playerStarted: this.clientStartTime,
            currentItem: meisterInstance.currentItem,
            duration: Math.floor(meisterInstance.duration),
            endDate: this.getCurrentTime() || "",
            fragmentDate: this.archiveFragmentStartTime || "",
            currentPercentage: this.currentFragmentPercentage || "",
            timeSpent: this.totalTimeSpent || 0,
            currentPlayerVolume: Math.round(this.currentPlayerVolume * 100).toFixed(),
            newPlayerVolume: Math.round(meisterInstance.volume * 100).toFixed()
        };
        return data;
    };
    return Player;
}(Widget_1.Widget));
exports.Player = Player;
